/**
 * Bundle Offers JavaScript
 * Handles the addition of bundle product variants to cart
 */

document.addEventListener("DOMContentLoaded", function () {
  // Find the bundle add to cart button
  const bundleAddToCartButton = document.getElementById("bundle-add-to-cart");

  if (!bundleAddToCartButton) return;

  // Track if a request is in progress to prevent multiple submissions
  let isAddingToCart = false;

  // Attach click event handler to the bundle add to cart button
  bundleAddToCartButton.addEventListener("click", function (event) {
    // Prevent the default form submission
    event.preventDefault();
    // Don't proceed if already processing a request
    if (isAddingToCart) return;

    // Set flag to indicate we're processing
    isAddingToCart = true;

    // Change button text/state to indicate loading
    const originalButtonText = bundleAddToCartButton.innerHTML;
    bundleAddToCartButton.innerHTML = "Adding...";
    bundleAddToCartButton.classList.add("is-adding");

    // Get all selected variants from bundle offer groups
    const selectedVariants = getSelectedBundleVariants();

    if (selectedVariants.length === 0) {
      // No variants selected, show error and reset button
      showMessage("Please select options for all bundle items", "error");
      resetButton();
      return;
    }

    // Add all selected variants to cart sequentially
    addBundleToCart(selectedVariants)
      .then(function (results) {
        // All items added successfully
        showMessage("Bundle added to cart!", "success");
        updateCartCount(results);

        // If there's a cart drawer or mini cart, trigger its update
        if (typeof window.updateCartDrawer === "function") {
          window.updateCartDrawer();
        }
      })
      .catch(function (error) {
        // Handle errors
        console.error("Error adding bundle to cart:", error);
        showMessage(
          "There was an error adding the bundle to cart. Please try again.",
          "error"
        );
      })
      .finally(function () {
        // Reset button state
        resetButton();
      });

    // Helper function to reset button state
    function resetButton() {
      bundleAddToCartButton.innerHTML = originalButtonText;
      bundleAddToCartButton.classList.remove("is-adding");
      isAddingToCart = false;
    }
  });

  /**
   * Gets all selected variants from bundle offer groups
   * @returns {Array} Array of variant IDs
   */
  function getSelectedBundleVariants() {
    const selectedVariants = [];
    const bundleOfferGroups = document.querySelectorAll(".bundle-offer-group");

    bundleOfferGroups.forEach(function (group) {
      const selectedRadio = group.querySelector('input[type="radio"]:checked');

      if (selectedRadio && selectedRadio.value) {
        selectedVariants.push({
          id: selectedRadio.value,
          quantity: 1,
        });
        console.log(selectedVariants);
      }
    });

    return selectedVariants;
  }

  /**
   * Adds all bundle variants to cart sequentially
   * @param {Array} variants Array of variant objects with id and quantity
   * @returns {Promise} Promise that resolves when all items are added
   */
  function addBundleToCart(variants) {
    // Create a copy of the variants array to avoid modifying the original
    const variantQueue = [...variants];
    const results = [];

    // Function to add items recursively
    function addNextItem() {
      if (variantQueue.length === 0) {
        return Promise.resolve(results);
      }

      const currentVariant = variantQueue.shift();

      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: currentVariant.id,
          quantity: currentVariant.quantity,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          results.push(data);
          return addNextItem();
        });
    }

    // Start the recursive chain
    return addNextItem();
  }

  /**
   * Shows a message to the user
   * @param {string} message The message to display
   * @param {string} type The type of message ('success' or 'error')
   */
  function showMessage(message, type) {
    // Look for an existing message container or create one
    let messageContainer = document.querySelector(".bundle-message");

    if (!messageContainer) {
      messageContainer = document.createElement("div");
      messageContainer.className = "bundle-message";
      bundleAddToCartButton.parentNode.insertBefore(
        messageContainer,
        bundleAddToCartButton.nextSibling
      );
    }

    // Set message content and styling
    messageContainer.textContent = message;
    messageContainer.className = `bundle-message bundle-message--${type}`;

    // Make the message visible
    messageContainer.style.display = "block";

    // Hide the message after 5 seconds
    setTimeout(function () {
      messageContainer.style.display = "none";
    }, 5000);
  }

  /**
   * Updates the cart item count in the UI
   * @param {Array} results Array of added items
   */
  function updateCartCount(results) {
    // Find cart count elements in the header
    const cartCountElements = document.querySelectorAll(
      ".cart-count, .cart-count-bubble, .site-header__cart-count"
    );

    if (cartCountElements.length === 0) return;

    // Get current cart count
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Update all cart count elements
        cartCountElements.forEach((element) => {
          element.textContent = cart.item_count;

          // Make sure the count is visible
          element.style.display = "block";
        });
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }
});
